import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {IntlProvider} from 'react-intl';

import {formatLocale, getLocale, getMessages, handleError} from './MessagesProvider.controller';

const value = {forceUpdate: () => undefined, updateLocale: {}};
const useUpdateLocale = () => value;

const MessagesProvider = ({children}) => {
  const [messages, setMessages] = useState(null);
  const [locale, setLocale] = useState();

  useEffect(() => {
    const fetchMessages = async () => {
      const locale = getLocale();
      setLocale(locale);
      setMessages(await getMessages(locale));
    };

    if (!messages) fetchMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    messages && (
      <IntlProvider locale={formatLocale(locale)} messages={messages} onError={handleError}>
        {children}
      </IntlProvider>
    )
  );
};

MessagesProvider.propTypes = {
  children: PropTypes.node,
};

export {MessagesProvider, useUpdateLocale};
